// hooks/useCategories.ts
import { useQuery } from '@tanstack/react-query';

import { getCategories, type Category } from '../api/v1/requests/categories';

export const useCategories = () => {
  return useQuery<Category[]>({
    queryKey: ['categories'],
    queryFn: getCategories,
  });
};
